import React from 'react';
import ReactDOM from 'react-dom';
import styles from '../../SingleListingGenerator/components/modals/modals.module.css';

// Prompt shown when the user tries to leave the bulk form.
// Lets them save the project as a draft, discard it, or cancel (close) and stay.
// Reuses the BgReminderModal styling for visual consistency within the bulk flow.
export const LeaveBulkFormModal = ({
  isOpen,
  onSaveDraft,
  onDiscard,
  onCancel,
  isSaving = false
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.removeBgModalOverlay} onClick={isSaving ? undefined : onCancel}>
      <div className={`${styles.addZoomModal} ${styles.bgReminderModal}`} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.addZoomModalClose} onClick={onCancel} disabled={isSaving} aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="#505050"/>
          </svg>
        </button>

        <div className={styles.bgReminderText}>
          <span className={styles.bgReminderHeadline}>
            Leave this project?
          </span>
          <span className={styles.bgReminderSubtext}>
            Save your progress as a draft to continue later, or discard it.
          </span>
        </div>

        <div className={styles.addZoomModalActions}>
          <button type="button" className={styles.addZoomModalPrimaryButton} onClick={onSaveDraft} disabled={isSaving}>
            {isSaving ? 'Saving...' : 'Save as Draft'}
          </button>
          <button type="button" className={styles.addZoomModalBackLink} onClick={onDiscard} disabled={isSaving}>
            Discard project
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
